// @flow
import type {
  GetSuggestions,
} from '../../core/suggestions';
import type {
  MiddlewareDriver,
} from '../drivers/middleware';

import * as r from 'ramda';
import { formNameToTld } from '../../domain/tld/utils';

export const getSuggestions = (
  middlewareDriver: MiddlewareDriver,
): GetSuggestions => (
  brandId,
  query,
  filters = {},
  exchangeRate,
  sessionId,
  bundle,
  usePPE,
  includeTax,
  unspunTlds,
) => {
  const data = r.pipe(
    r.assoc('query', query),
    r.assoc('price', filters.price),
    r.when(
      r.always(r.has('length', filters)),
      r.assocPath([ 'length', 'max' ], filters.length),
    ),
    r.assoc('tlds', r.cond([
      [
        r.prop('unspun'),
        r.always(unspunTlds),
      ],
      [
        r.prop('tld'),
        r.pipe(
          r.prop('tld'),
          r.filter(r.equals(true)),
          r.keys,
          r.map(
            formNameToTld,
          ),
        ),
      ],
      [
        r.T,
        r.always(void 0),
      ],
    ])(filters)),
    r.assoc('location', filters.location),
    r.assoc('premiumOnly', filters.premium),
    r.assoc('unspun', filters.unspun),
    r.assoc('brandId', brandId),
    r.assoc('exchangeRate', exchangeRate),
    r.assoc('user_vguid', sessionId),
    r.assoc('bundle', r.ifElse(
      r.propEq('enable', true),
      r.dissoc('enable'),
      r.always(void 0),
    )(bundle)),
    r.when(
      r.always(r.equals(usePPE, true)),
      r.assoc('includeTax', includeTax),
    ),
    r.reject(
      r.either(
        r.isNil,
        r.isEmpty,
      ),
    ),
  )({});

  const method = r.ifElse(
    r.equals(true),
    r.always('v2.getSuggestions'),
    r.always('v0.getSuggestions'),
  )(usePPE);

  return middlewareDriver({
    method,
    data,
  });
};

export default getSuggestions;
